import React from "react";
import Footer from "../../../components/layout/Footer/Footer";
import {
  BlickTitle,
  BlickTitle4,
  Block1,
  Block2,
  Block3,
  Block4,
  BlockText,
  BlockText4,
  BlockTextCont,
  Btn,
  Btn4,
  BtnCont,
  Title,
} from "./styles";

const Services = () => {
  return (
    <>
      <Title>Услуги</Title>
      <Block1>
        <BlickTitle>Психология и консалтинг</BlickTitle>
        <BlockTextCont>
          <BlockText>
            Для тех, кто устал от текущей деятельности, чувствует выгорание или
            хочет разобраться в себе. Помогаем заглянуть в себя и ответить
            честно на волнующие вопросы. Углубленная проработка целей, поиск
            внутренней опоры, систематическая работа с убеждениями и внутренними
            ограничениями помогает создать план действий для достижения
            масштабных карьерных целей.
          </BlockText>
          <BtnCont>
            <Btn href="/services/talkitout">Выговориться</Btn>
            <Btn href="/services/supportduringtheprobationaryperiod">
              Сопровождение испытательного срока
            </Btn>
          </BtnCont>
        </BlockTextCont>
      </Block1>
      <Block2>
        <BlickTitle>Поиск работы</BlickTitle>
        <BlockTextCont>
          <BlockText>
            Для тех, кто не хочет тратить время и силы на поиск, и хочет
            получить максимальный результат. Для тех, кто хочет найти новую
            работу с подходящими условиями быстрее.
          </BlockText>
          <BtnCont>
            <Btn href="/services/careerconsulting">Карьерная консультация</Btn>
            <Btn href="/services/supportduringthejobsearchsupport">
              Сопровождение поиска работы
            </Btn>
            <Btn href="/services/cvready">Резюме «Под ключ»</Btn>
            <Btn href="/services/vs">Подписка на ведение вакансий</Btn>
          </BtnCont>
        </BlockTextCont>
      </Block2>
      <Block3>
        <BlickTitle>Подбор IT специалистов</BlickTitle>
        <BlockTextCont>
          <BlockText>
            Мы разработали три формата пакетного ведения под разные запросы:
            <br />
            пассивный поиск, активный поиск и закрытие позиции «под ключ».
          </BlockText>
          <BtnCont>
            <Btn href="/services/recruitmentofITspecialists">Подробнее</Btn>
          </BtnCont>
        </BlockTextCont>
      </Block3>
      <Block4>
        <BlickTitle4>Обучение IT Рекрутер</BlickTitle4>
        <BlockTextCont>
          <BlockText4>
            Авторский курс Любови Прохоровой – это возможность освоить новую
            профессию, в которой будет интересно работать. Наши студенты
            устраиваются на первую работу уже буквально внутри обучения.
          </BlockText4>
          <BtnCont>
            <Btn4 href="/services/trainingofITrecruiters">Подробнее</Btn4>
          </BtnCont>
        </BlockTextCont>
      </Block4>
      <Footer />
    </>
  );
};
export default Services;
